import React, { useRef, useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import arabic from "react-date-object/calendars/arabic";
import arabic_en from "react-date-object/locales/arabic_en";
import "./datePicker.css";
import dateIcon from "../../../../assets/images/dateIcon.svg";

const HijriDatePicker = ({ value, onChange }) => {
  const wrapperRef = useRef(null);
  const datePickerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  // Handle click outside to close the calendar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        datePickerRef.current.closeCalendar(); // Close the calendar
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.openCalendar();
      setIsOpen(true);
    }
  };

  return (
    <div className="add-input-wrapper" ref={wrapperRef}>
      <DatePicker
        ref={datePickerRef}
        value={value}
        format="DD-MM-YYYY"
        onChange={(dateObject) => {
          if (!dateObject) {
            onChange("");
            return;
          }

          const formattedDate = dateObject.format("DD-MM-YYYY");
          onChange(formattedDate);
        }}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        placeholder="dd-mm-yyyy"
        calendar={arabic}
        locale={arabic_en}
      />
      <img
        src={dateIcon}
        alt="date icon"
        className="add-input-in"
        onClick={handleIconClick}
      />
    </div>
  );
};

export default HijriDatePicker;
